<template>
  <svg 
    viewPort="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    class="-rotate-90 transition block"
    :width="width"
    :height="width"
    ref="$progress"
  >
    <circle :r="(width / 2) - (stroke / 2)" cx="50%" cy="50%" fill="transparent" class="stroke-emerald-200" :stroke-width="stroke" />

    <circle :r="(width / 2) - (stroke / 2)" cx="50%" cy="50%" fill="transparent" class="stroke-tiger-200" :stroke-width="stroke" :style="{ opacity: Math.max(0, 1.25 - completion) }" />

    <circle :r="(width / 2) - (stroke / 2)" cx="50%" cy="50%" fill="transparent" class="stroke-emerald-500" :stroke-width="stroke" 
      :style="{
        strokeDasharray: maxProgress,
        strokeDashoffset: currentProgress
      }"
      ref="$circle"
    />

    <circle :r="(width / 2) - (stroke / 2)" cx="50%" cy="50%" fill="transparent" class="stroke-tiger-400" :stroke-width="stroke" 
      :style="{
        strokeDasharray: maxProgress,
        strokeDashoffset: currentProgress,
        opacity: Math.max(0, 1.25 - completion)
      }"
      v-if="completion < 1"
    />

    <!-- transition: 'stroke-dashoffset 100ms linear' -->
  </svg>
</template>

<script lang="ts" setup>

const props = withDefaults(defineProps<{
  completion: number
  width?: number
  stroke?: number
}>(), {
  width: 20,
  stroke: 5
})

const $circle = ref()

const maxProgress = computed(() => $circle.value ? $circle.value.getTotalLength() : 0)
const currentProgress = computed(() => Math.max(0, maxProgress.value * (1 - props.completion)))
</script>